export enum NewProductPlanStatusEnum {
    InProgress = "InProgress",
    active = "active",
    completed = "completed",
    cancelled = "cancelled",
    failed = "failed",
}
